import * as actionTypes from './actionTypes';

export const fetchOfficeSuccess = (val) => {
  return {
    type: actionTypes.FETCH_OFFICE_SUCCESS,
    val: val
  }
}